import ServiceError from "./ServiceError"

import ApiClient from "./ApiClient"
import { compareDates, getDate } from "./serviceUtils"

export const TaskStatus = {
  OPEN_IN_FUTURE: "OPEN_IN_FUTURE",
  OPEN_CURRENT: "OPEN_CURRENT",
  STARTED: "STARTED",
  EVALUATION_PENDING: "EVALUATION_PENDING",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  UNKNOWN: "UNKNOWN",
}

export const TasksStatus = {
  oneOpenTask: "oneOpenTask",
  severalOpenTasks: "severalOpenTasks",
  noOpenTasks: "noOpenTasks",
}

const getApiClient = () =>
  new ApiClient(
    "education",
    `${process.env.PERSONALISATION_HOST}/api/education/`
  )

const tasksDataMapper = data => {
  if (!Array.isArray(data.tasks)) {
    console.error("Unexpected education tasks response", data)
    throw new ServiceError(
      ServiceError.STATUS_INVALID_DATA,
      "Education service got unexpected data"
    )
  }
  const result = data.tasks.map(task => ({
    ...task,
    start: getDate(task.start),
    end: getDate(task.end),
  }))
  result.sort((a, b) => {
    const startComp = compareDates(a.start, b.start)
    if (startComp === 0) {
      return compareDates(a.end, b.end)
    }
    return startComp
  })
  return result
}

/**
 * Will return all education tasks ordered by task period
 */
export async function getTasks() {
  return getApiClient().get("tasks", tasksDataMapper)
}

export async function getTaskStatus() {
  const tasks = await getTasks()
  const openTasks = tasks.filter(
    task => task.status.key !== TaskStatus.COMPLETED
  )
  if (openTasks.length > 0) {
    return {
      status:
        openTasks.length === 1
          ? TasksStatus.oneOpenTask
          : TasksStatus.severalOpenTasks,
      tasksCount: openTasks.length,
    }
  }
  return {
    status: TasksStatus.noOpenTasks,
    tasksCount: 0,
  }
}
